import React from "react";
import "./formTitle.scss";

const FormTitle = ({ title, description }) => {
  return (
    <div className="formTitle">
      <h2> {title} </h2>
      <p>{description}</p>
    </div>
  );
};

export default FormTitle;
